import pick from 'lodash/pick'
import D2C_ServiceWeb from './Web'

class D2C_ServiceNginxCluster extends D2C_ServiceWeb {
  static objectType = 'serviceType'
  static active = false
  static order = 31
  static typeName = 'nginxCluster'
  static typeTitle = 'Nginx Cluster'
  static color = '#008833'
  static methods = {
    ...D2C_ServiceWeb.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceWeb.fields,
    configs: {
      ...D2C_ServiceWeb.fields.configs,
      default: [
        {name: 'nginx.conf', text: require('raw-loader!@/assets/configs/nginxCluster-nginx.conf').default, custom: false},
      ],
    },
    hosts: {
      ...D2C_ServiceWeb.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceWeb.fields.image,
      default: 'd2cio/nginx',
    },
    ports: {
      ...D2C_ServiceWeb.fields.ports,
      default: [
        {protocol: 'TCP', value: 80},
      ],
    },
    services: {
      default: [],
      label: 'Configure services',
      path: 'services',
      required: false,
      serviceConfig: require('raw-loader!@/assets/configs/nginxCluster.tpl').default,
      serviceConfigFields: ['config', 'id', 'name'],
      serviceConfigVariables: ['$serviceName', '$servicePort'],
      serviceConfigLimit: 0,
      serviceConfigSuffix: '-www',
      serviceMethod: 'serve',
      servicePortProtocols: ['TCP', 'UDP'],
      serviceConfigModes: [
        {value: 'proxy', text: 'Proxy'},
        {value: 'uwsgi', text: 'uWSGI'},
        {value: 'fastcgi', text: 'FastCGI'},
      ],
      syntax: 'nginx',
      validate() {
        return null
      },
      prepare(value) {
        return value.map(config => {
          return pick(config, ['config', 'id', 'name', 'static'])
        })
      },
      creating: {},
      updating: {},
      updatingServices: {},
      importing: {
        hidden: true,
      },
    },
    version: {
      ...D2C_ServiceWeb.fields.version,
      default: '1.17',
      enum: ['1.16', '1.17'],
    },
    volumes: {
      ...D2C_ServiceWeb.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/configs', dst: '/etc/nginx/conf.d', sync: false},
      ],
    },
  }
}

export default D2C_ServiceNginxCluster
